<template>
	<div>
		<v-tabs
			v-model="val"
			:show-arrows="true"
			class="pa-1"
		>
			<v-tab
				v-for="(tab, key) in tabs"
				:key="`tab-${key}`"
			>
				<v-icon v-if="$vuetify.breakpoint.xsOnly">
					{{ tab.icon }}
				</v-icon>
				<span v-else>
					{{ tab.title }}
				</span>
			</v-tab>
		</v-tabs>

		<v-tabs-items v-model="val">
			<v-tab-item
				v-for="(tab, key) in tabs"
				:key="`tab-item-${key}`"
			>
				<component
					:is="tab.component.name"
					v-bind="tab.component.props"
					v-on="tab.component.events"
				/>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import RepairOrderMediaCreateModal from '@/components/orders/repair/media/create-modal';
import RepairOrderShowClientData from '@/components/orders/repair/show/client-data';
import RepairOrderShowSummary from '@/components/orders/repair/show/summary';
import RepairOrderShowMessages from '@/components/orders/repair/show/messages';
import RepairOrderShowActivity from '@/components/orders/repair/show/activity';
import RepairOrderShowDiagnostics from '@/components/orders/repair/show/diagnostics';
import RepairOrderPositions from '@/components/orders/repair/show/positions';

export default {
	name: 'STabs',
	components: {
		RepairOrderShowSummary,
		RepairOrderShowClientData,
		RepairOrderMediaCreateModal,
		RepairOrderShowMessages,
		RepairOrderShowActivity,
		RepairOrderShowDiagnostics,
		RepairOrderPositions,
	},
	props: {
		tabs: {
			type: Array,
			required: true,
		},
	},
	data: () => ({
		val: 0,
	}),
};
</script>

<style lang="scss">
.tabs-without-arrows .v-slide-group__prev {
	display: none !important;
}
</style>
